import React from 'react';
import styled from 'styled-components';
import useTranslation from 'shared/hooks/useTranslation';

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  height: 14vh;
  margin-bottom: -4rem;
  margin-left: 6%;
  max-width: 80%;
  padding-top: 4rem;
  color: white;
`;

const BadgeHeader = styled.h1`
  font-weight: 700;
  font-size: 3.2rem;
  line-height: 1.2;
  width: 100%;
  color: white;

  @media (-webkit-min-device-pixel-ratio: 1.25) {
    font-size: 2.4rem;
  }
`;

const Description = styled.div`
  font-size: 2.4rem;

  @media (-webkit-min-device-pixel-ratio: 1.25) {
    font-size: 1.6rem;
  }
`;

export default function Header(): JSX.Element {
  const { t } = useTranslation('badgesPage');

  return (
    <HeaderSection>
      <BadgeHeader>{t('earnBadges')}</BadgeHeader>
      <Description>{t('specialAwards')}</Description>
    </HeaderSection>
  );
}
